define('views/content/home',['require','backbone','marionette','text!templates/content/home.html'],function(require){

	var Backbone = require('backbone');
	require('marionette');
	
	var temp = require("text!templates/content/home.html");

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
		template: _.template(temp),
		className: 'home-page',
        titleKey: 'home',

		initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
		}

	});
});
